var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlert)?_c('Alert',{staticClass:"my-4",attrs:{"dismissible":"","data-testid":_vm.dataTestid,"vuetifyProps":{
    color: 'green',
    dismissible: true,
    icon: 'mdi-cash-multiple',
  },"text":_vm.alertText},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('PredictedFinancialImpactInfoTooltip',{attrs:{"data-testid":"predictedFinancialImpactAlert-infoIcon","iconClass":"ms-3","iconColor":"green","text":_vm.$t('rev.financial_potential_impact.tooltip')}})]},proxy:true}],null,false,1594933836)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }